import './Loading.scss';

function Loading() {
  return (
    <div className='spin'></div>
  )
}

export default Loading